import React from 'react';
import VoucherListFunctional from './components/voucher-list-functional';
import './voucher-print.scss';

const VoucherList = () => {
	return <VoucherListFunctional />;
};

export default VoucherList;
